import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import { ReactNode } from "react";

interface SaveButtonProps {
    loading: boolean;
    disabled?: boolean;
    onClick: () => void;
    label?: ReactNode
}

export const SaveButton: React.FC<SaveButtonProps> = ({ loading, disabled = false, onClick, label }) => {
    return (
        <LoadingButton
            loading={loading}
            disabled={disabled}
            size="small"
            color="success"
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={onClick}
        >
            {label ? label : <Localized id="save">Zapisz</Localized>}
        </LoadingButton>
    );
};
